<template>
  <div class="value-item" :class="{ '-sales': sales }">
    <img :src="iconSource" alt="" class="icon">
    <div class="titlewrap">
      <h3 class="title">
        {{ item.title }}
      </h3>
    </div>
    <p class="text">
      {{ item.text }}
    </p>
  </div>
</template>

<script>
export default {
  props: {
    item: Object,
    sales: Boolean,
  },
  computed: {
    iconSource() {
      // eslint-disable-next-line import/no-dynamic-require, global-require
      return require(`@/assets/icons/${this.item.icon}.svg`);
    },
  },
};
</script>

<style lang="scss" scoped>
.value-item {
  background-color: white;
  padding: 70px 25px 25px;
  margin-bottom: 30px;
  text-align: center;
  box-shadow: 0 6px 30px 0 rgba(0,0,0,0.17);
  position: relative;
  .icon {
    display: block;
    width: 70px;
    height: 70px;
    margin: 0 auto 30px;
  }
  .titlewrap {
    margin-bottom: 20px;
    height: 38px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .title {
    font-size: 18px;
  }
  &::before {
    content: "";
    display: block;
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    height: 16px;
    background-color: $primary;
  }
  &.-sales {
    &::before {
      height: 26px;
      background-color: transparent;
      background-image: url('../assets/patterns/check-pattern.svg');
      background-size: auto 100%;
    }
  }
  @media screen and (min-width: $screen-md) {
    min-height: 365px;
    margin-bottom: 30px;
  }
}
</style>
